import SelectDinamico from "../../SelectDinamico";
import ConsultaMoeda from "../../../../lib/json/consultas/Moeda.json"

function SelectMoeda({campoMoeda, changeMoeda, queryMoeda, disabled = false, empresaLogada, returnOriginal = false, loadDefault = true, bindItem, field}){
    const empresaFilial = empresaLogada || localStorage.getItem('empresaFilial')    
    const cConsultaDefault = ConsultaMoeda.consulta + " WHERE X6_VAR LIKE 'MV_MOEDA%' AND NOT X6_VAR LIKE 'MV_MOEDAP%' AND NOT X6_VAR LIKE 'MV_MOEDAC%' AND D_E_L_E_T_ <> '*' AND X6_FIL = FILIAL(SX6) "
    const consulta = queryMoeda || ( loadDefault ? cConsultaDefault : '' )
    const localEstoqueValue = bindItem ? bindItem[field] : campoMoeda;

    return (
        <SelectDinamico
            label="Moeda"
            cText="CODIGO.trim() + ' - ' + item.X6_CONTEUD.trim()"
            cValue="CODIGO.trim()"
            campoValue={localEstoqueValue}
            consulta={consulta}
            tabela={ConsultaMoeda.tabelas}
            isMultiplo={false}
            showNoFilter={false}
            EmpresaLogada={empresaFilial}
            onchange={(e) => changeMoeda(e)}
            returnOrigem={returnOriginal}
            bindItem={bindItem}
            field={field}
            disabled={disabled}
        />
    )
}

export default SelectMoeda;